<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="title">
			<div id="notice">
				<h5>收款计划审核信息&nbsp;&nbsp;说明:</h5><br>
				<span>1、业务逻辑<br>
				&nbsp;&nbsp;&nbsp;&nbsp;步骤A:首先定义收款计划,完成后自动生成收款明细。<br>
				&nbsp;&nbsp;&nbsp;&nbsp;步骤B:等待领导审核,通过后方能开始录入具体收款明细。<br>
				&nbsp;&nbsp;&nbsp;&nbsp;具体收款明细可以在相关弹窗中查看</span><br>
				<span>2、可以通过销售订单直接生成相关的收款计划</span><br>
				<span>3、查询关键字:业务单号、车牌、付款人、付款人电话、签订日期、到期日期、是否逾期、管理订单</span><br>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
		<!-- 		<button @click="edit_mode">添加收款明细</button>
				<button @click="edit_mode">发起延期申请</button> -->
			</template>
		</pre-base>


	</div>
</template>

<script>
	import api from '@/utils/type.js'

	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				element_loading: false,
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "paysheetpass",
					"title": "收款计划审核",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_cw_paysheet_m_p',
					"upd_action": 'exp30_cw_paysheet_m_p',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "1",
					"detail_excelup": "0",
					"d_btn_base": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_cw_paysheet_d',
					"d_upd_action": 'exp15_cw_paysheet_d',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "付款人",
							"val": "",
							"key": "pay_user",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "付款人电话",
							"val": "",
							"key": "pay_userphone",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "签订日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "到期日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "是否逾期",
							"val": "",
							"key": "wanning",
							"type": "select",
							"class": "long1",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_action": "",
							"sel_name": ""
						},
						{
							"name": "销售订单",
							"val": "",
							"key": "sheet_xs",
							"type": "text",
							"class": "long1"
						}
					],
					"parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u2_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "签约日期",
							"val": "",
							"key": "s_date",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "几号收款",
							"val": "10",
							"key": "pay_day",
							"type": "number",
							"class": "long1",
							"note": "请填入1-28号",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "还款期数",
							"val": "",
							"key": "pay_num",
							"type": "number",
							"class": "long1",
							"note": "请填入0-36.0为一次性",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "年利率",
							"val": "",
							"key": "year_rate",
							"type": "number",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "预警天数",
							"val": "",
							"key": "warning_day",
							"type": "number",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "滞纳金比例",
							"val": "0.0006",
							"key": "over_ratio",
							"type": "number",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "预付保证性租金",
							"val": "0",
							"key": "pay_month_more",
							"type": "none",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "3"
						},
						{
							"name": "付款人",
							"val": "",
							"key": "pay_user",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "3"
						},
						{
							"name": "付款电话",
							"val": "",
							"key": "pay_phone",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "3"
						},
						{
							"name": "应付金额",
							"val": "",
							"key": "amount",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "3"
						},

						{
							"name": "首付金额",
							"val": "",
							"key": "pay_first",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "3"
						},
						{
							"name": "销售订单",
							"val": "",
							"key": "sheet_xs",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "应付合计",
							"val": "",
							"key": "amount_all",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "应付利息",
							"val": "",
							"key": "pay_rate",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "应付本金",
							"val": "",
							"key": "pay_base",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "应付逾期",
							"val": "",
							"key": "pay_fee",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "应付月保",
							"val": "",
							"key": "pay_month",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "实收合计",
							"val": "",
							"key": "rec_all",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "实收利息",
							"val": "",
							"key": "rec_rate",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "实收本金",
							"val": "",
							"key": "rec_base",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "实收逾期",
							"val": "",
							"key": "rec_fee",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "实收月保",
							"val": "",
							"key": "rec_month",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "首个还款日",
							"val": "",
							"key": "f_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long4",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "6"
						},
						{
							"name": "审核备注",
							"val": "",
							"key": "p_note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "7"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "经办人"
						},
						// {
						// 	"name": "状态"
						// },
						{
							"name": "状态"
						},
						{
							"name": "审核人"
						},
						{
							"name": "审核说明"
						},
						{
							"name": "销售订单"
						},
						{
							"name": "车牌"
						},
						{
							"name": "付款方"
						},
						{
							"name": "付款方电话"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "结束日期"
						},
						{
							"name": "全款金额"
						},
						{
							"name": "首付金额"
						},
						{
							"name": "分期期数"
						},
						{
							"name": "年利息"
						},
						{
							"name": "几号还款"
						},
						{
							"name": "提前预警天数"
						},
						{
							"name": "滞纳金比例"
						},
						{
							"name": "月保证金"
						},
						

						{
							"name": "应收合计"
						},
						{
							"name": "应收利息"
						},
						{
							"name": "应收本金"
						},
						{
							"name": "应收逾期"
						},
						{
							"name": "应收月保"
						},
						
						{
							"name": "已收合计"
						},
						{
							"name": "已收利息"
						},
						
						{
							"name": "已收本金"
						},
						{
							"name": "已收逾期"
						},
						{
							"name": "已收月保"
						},
						
						{
							"name": "免除金额"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": [
						{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "还款日期"
						},
						{
							"name": "原应还款日期"
						},
						{
							"name": "应还本金"
						},
						{
							"name": "应还利息"
						},
						{
							"name": "计息天数"
						},
						{
							"name": "应交滞纳金"
						},
						{
							"name": "逾期天数"
						},
						{
							"name": "应收总额"
						},
						{
							"name": "已还本金"
						},
						{
							"name": "已还利息"
						},
						{
							"name": "已交滞纳金"
						},
						{
							"name": "实收月保"
						},
						{
							"name": "实收金额"
						},
						{
							"name": "剩余本金"
						},
						{
							"name": "备注"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					],

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}




		}
	};
</script>
<style>
</style>